import { Stack } from 'primitives/containers'
import React from 'react'
import { useSelector } from 'react-redux'

import { getCurrentQuestion } from '../../reduxes/slices/questions/selectors'
import { getLiveChatTopics } from '../../reduxes/slices/topics/selectors'

type Props = {
  children?: any
}

export const WelcomeMessage = ({ children }: Props) => {
  const topics: any = useSelector(getLiveChatTopics)
  const currentQuestion = useSelector(getCurrentQuestion)

  return (
    <Stack
      css={{
        flexGrow: 1,
        padding: '$4 0',
      }}
    >
      {!topics.length && (
        <>
          {' '}
          <Stack css={{ fontSize: '$6' }}>{currentQuestion.text}</Stack>
        </>
      )}
      {children}
    </Stack>
  )
}
